export default "__VITE_ASSET__g33U085j__"